import { Injectable } from '@angular/core';
import { InveniasEntityTypes } from 'datasource-service-lib';
import { EntityControllerService } from 'entity-picker-lib';
import { IDataSourceApiService, IEntity, INamedEntity } from 'interfaces-lib';
import { Observable, of, ReplaySubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { InveniasSharedServiceProviderService } from 'shared-service-provider-lib';
import { INamedEntityService } from './inamed-entity.service';

@Injectable({ providedIn: 'root' })
export class InveniasNamedEntityService implements INamedEntityService {
  private apiService: IDataSourceApiService;

  namedEntitySubject = new ReplaySubject<INamedEntity>();
  namedEntitySelected$: Observable<INamedEntity> = this.namedEntitySubject.asObservable();

  constructor(private entityControllerService: EntityControllerService, sps: InveniasSharedServiceProviderService) {
    this.apiService = sps.getDataSourceApiService();
    this.entityControllerService.entitySelected$.subscribe((entity) =>
      this.getNamedEntity(entity as IEntity).subscribe((namedEntity) => {
        if (namedEntity) {
          this.namedEntitySubject.next(namedEntity);
        }
      })
    );
  }

  private getNamedEntity(entity: IEntity): Observable<INamedEntity | undefined> {
    if (!entity) {
      return of(undefined);
    }

    switch (entity.type) {
      case InveniasEntityTypes.People:
        return this.apiService.get(entity).pipe(map((entityData) => this.peopleMapper(entity, entityData)));
      case InveniasEntityTypes.Assignments:
        return this.apiService.get(entity).pipe(map((entityData) => this.assignmentsMapper(entity, entityData)));
      case InveniasEntityTypes.Companies:
        return this.apiService.get(entity).pipe(map((entityData) => this.companiesMapper(entity, entityData)));
      case InveniasEntityTypes.Programmes:
        return this.apiService.get(entity).pipe(map((entityData) => this.programmesMapper(entity, entityData)));
      default:
        return of(undefined);
    }
  }

  peopleMapper(entity: IEntity, entityData: any): INamedEntity {
    return {
      id: entity.id,
      type: entity.type,
      name: entityData.NameComponents.FullName,
    };
  }

  assignmentsMapper(entity: IEntity, entityData: any): INamedEntity {
    return {
      id: entity.id,
      type: entity.type,
      name: entityData.AssignmentName,
    };
  }

  companiesMapper(entity: IEntity, entityData: any): INamedEntity {
    return { id: entity.id, type: entity.type, name: entityData.CompanyName };
  }

  programmesMapper(entity: IEntity, entityData: any): INamedEntity {
    return { id: entity.id, type: entity.type, name: entityData.ProgrammeName };
  }
}
